import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Gift, X } from "lucide-react";
import { scrollToId } from "../hooks/useLenis";

export const FloatingGiftPopup = () => {
  const [dismissed, setDismissed] = useState(false);

  return (
    <AnimatePresence>
      {!dismissed && (
        <motion.div
          data-testid="floating-gift-popup"
          initial={{ opacity: 0, x: 100, scale: 0.9 }}
          animate={{ opacity: 1, x: 0, scale: 1 }}
          exit={{ opacity: 0, x: 100, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 240, damping: 20 }}
          className="fixed top-[78px] left-3 right-3 sm:left-auto sm:right-6 sm:top-[86px] sm:w-[380px] z-[60]"
        >
          <motion.div
            animate={{ rotate: [0, -1.5, 1.5, 0] }}
            transition={{ duration: 0.5, repeat: Infinity, repeatDelay: 5 }}
            className="flex items-center gap-3.5 rounded-full bg-[#16a34a] text-white pl-4 pr-2.5 py-2.5 shadow-[0_20px_60px_-12px_rgba(22,163,74,0.75)] ring-2 ring-white/30"
          >
            <span className="relative flex w-10 h-10 shrink-0 items-center justify-center rounded-full bg-white/15">
              <Gift className="w-5 h-5 text-white relative z-10" />
              <motion.span
                className="absolute inset-0 rounded-full bg-white/30"
                animate={{ opacity: [0.7, 0], scale: [1, 1.7] }}
                transition={{ duration: 1.8, repeat: Infinity, ease: "easeOut" }}
              />
            </span>

            <div className="min-w-0">
              <p className="font-display font-extrabold text-sm sm:text-base leading-tight tracking-tight">
                1 000 kr presentkort på köpet!
              </p>
              <p className="text-[11px] text-green-100 mt-0.5">IKEA · Hemtex · Cervera</p>
            </div>

            <button
              data-testid="floating-gift-cta"
              onClick={() => scrollToId("#offert")}
              className="shrink-0 bg-white text-[#16a34a] hover:bg-green-50 font-bold text-xs px-4 py-2.5 rounded-full transition-colors duration-300"
            >
              Välj
            </button>

            <button
              data-testid="floating-gift-close"
              onClick={() => setDismissed(true)}
              aria-label="Stäng popup"
              className="shrink-0 w-7 h-7 rounded-full bg-white/10 hover:bg-white/25 flex items-center justify-center text-white transition-colors duration-300"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
